const S3_SIGNATURE_KEYS = [
  'x-amz-algorithm',
  'x-amz-signature',
  'x-amz-credential',
  'x-amz-date',
  'x-amz-security-token',
];

function fnParseUrl(cUrl) {
  try {
    if (typeof cUrl !== 'string' || cUrl.trim() === '') return null;
    const cBase = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    return new URL(cUrl, cBase);
  } catch (e) {
    return null;
  }
}

export function fnIsPresignedS3Url(cUrl) {
  const oUrl = fnParseUrl(cUrl);
  if (!oUrl) return false;

  const cSearch = oUrl.searchParams;
  return S3_SIGNATURE_KEYS.some((cKey) => cSearch.has(cKey) || cSearch.has(cKey.toUpperCase()));
}

export function fnShouldUseAuthenticatedRequest(cUrl) {
  if (typeof cUrl !== 'string' || cUrl.trim() === '') return false;
  if (cUrl.startsWith('blob:') || cUrl.startsWith('data:')) return false;
  if (fnIsPresignedS3Url(cUrl)) return false;

  const bIsRelative = cUrl.startsWith('/');
  if (bIsRelative) return true;

  const oUrl = fnParseUrl(cUrl);
  if (!oUrl) return true;

  const cWindowHost = typeof window !== 'undefined' ? window.location.host : '';
  if (oUrl.host === cWindowHost) return true;

  const aApiCandidates = [
    process.env.REACT_APP_API_URL,
    process.env.REACT_APP_API_BASE_URL,
    process.env.REACT_APP_URL,
  ].filter(Boolean);

  const aApiHosts = aApiCandidates
    .map((cValue) => {
      try {
        return new URL(cValue).host;
      } catch (e) {
        return '';
      }
    })
    .filter(Boolean);

  if (aApiHosts.includes(oUrl.host)) return true;

  return false;
}
